import React from 'react';
import { UI } from 'src/apps/invest/signup/views/components/UI';
import { useSignUpModel } from '../../models/SignUpModel';
import { PasswordForm } from '../components/PasswordForm';
import { Transition } from '../components/Transition';

export const SignUpPasswordPage: React.FC = () => {
  const { password } = useSignUpModel();
  return (
    <UI
      prevPage={() => useSignUpModel.setState({ page: 'EMAIL' })}
      nextPage={password ? () => useSignUpModel.setState({ page: 'NAME' }) : undefined}>
      <Transition>
        <PasswordForm />
      </Transition>
    </UI>
  );
};
